import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { addService, editService } from 'actions/provider';
import Button from 'atoms/button';
import Dropdown from 'atoms/dropdown';
import Icon from 'atoms/icon';
import Input from 'atoms/input';
import { setService } from 'store/reducers/serviceForm';
import { durationOptions } from 'util/constants';

export default function ServiceInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocation = useSelector((state) => state.provider.locations)?.[0];
  const serviceForm = useSelector((state) => state.serviceForm);
  const { core } = useSelector((state) => state.main);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [animalTypeId, setAnimalTypeId] = useState('');
  const [durationMinutes, setDuration] = useState('');
  const [amount, setAmount] = useState('');

  const isFormComplete =
    name && description && animalTypeId && durationMinutes && amount;

  useEffect(() => {
    if (serviceForm.uuid) {
      setDescription(serviceForm.description);
      setAnimalTypeId(serviceForm.animal.type);
      setDuration({
        value: `${serviceForm.durationMinutes} min`,
        id: serviceForm.durationMinutes,
      });
      setName(serviceForm.name);
      setAmount(serviceForm.price.amount);
    }
  }, []);

  const onNext = async (e) => {
    e.preventDefault();
    if (isFormComplete) {
      const body = {
        name,
        description,
        animalTypeId: animalTypeId?.id,
        amount: Number(amount),
        durationMinutes: durationMinutes?.id,
        typeId: currentLocation?.type?.[0]?.id,
      };

      if (serviceForm.uuid) {
        const serviceEdited = await dispatch(
          editService(body, serviceForm.uuid)
        );

        if (serviceEdited.success) {
          const serviceData = serviceEdited.data.data;
          dataSetSuccesfully(serviceData);
        }
      } else {
        const serviceCreated = await dispatch(addService(body));

        if (serviceCreated.success) {
          const serviceData = serviceCreated.data.data;
          dataSetSuccesfully(serviceData);
        }
      }
    }
  };

  const dataSetSuccesfully = (serviceData) => {
    dispatch(setService(serviceData));

    navigate('optional');
  };

  return (
    <div className="add-service pb-20">
      {/* <Link to="/services">
        <Icon name="arrowLeft" className="mb-15" />
      </Link> */}
      <h1>Add service</h1>
      <form onSubmit={onNext}>
        <Input
          id="name"
          label="Service"
          placeholder="Service title"
          autoFocus
          onChange={(value) => setName(value)}
          value={name}
        />
        <Input
          id="description"
          label="Description"
          placeholder="Describe the service"
          inputType="textarea"
          className="textarea"
          onChange={(value) => setDescription(value)}
          value={description}
        />
        <Dropdown
          id="type"
          label="What type of animal is this for?"
          placeholder="Type"
          className="mt-35"
          items={core.type}
          onClick={(value) => setAnimalTypeId(value)}
          value={animalTypeId}
        />
        <div className="flex-row align-end">
          <Dropdown
            id="time"
            label="Time"
            className="w-100 hide-label mr-10"
            placeholder="Duration"
            items={durationOptions}
            onClick={(value) => setDuration(value)}
            value={durationMinutes}
          />
          <Input
            id="amount"
            label="Cost"
            placeholder="(i.e. $150)"
            className="w-100"
            isMoney
            onChange={(value) => setAmount(value)}
            value={amount}
          />
        </div>
        <Button
          variant={!isFormComplete ? 'disabled' : 'default'}
          type="submit"
          text="Next"
          className="mb-35 mt-30"
        />
      </form>
    </div>
  );
}
